import React, { useEffect, useState } from 'react';
import { useUser } from '../../auth/UseUser';
import { SubmitHandler, useForm } from 'react-hook-form';
import Loading from '../../utils/Loading';
import { ReactComponent as ConfirmIcon } from '../../assets/svg/ConfirmIcon.svg';
import { createPuskica, getPuskicaById, updatePuskica } from '../../server/server-puskica';
import { ReactComponent as DeleteIcon } from '../../assets/svg/DeleteIcon.svg';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as TargetUndo } from '../../assets/svg/undoTarget.svg';
import { notif } from '../utils/util';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

type Inputs = {
    naziv: string;
    redosled: number | undefined;
};
function SinglePuskica() {
    const { setShowSelectedPuskica, setIsAdminApp, selectedPuskica, setSelectedPuskica, selectedPitanja, setSelectedPitanja } = useUser();
    const [puskica, setPuskica] = useState<any>(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [hoveredButton, setHoveredButton] = useState(false);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (!!selectedPuskica?.id) loadPuskica();
    }, [selectedPuskica?.id]);

    const loadPuskica = async () => {
        const resp = await getPuskicaById(selectedPuskica?.id);
        if (resp.status == 200) {
            setPuskica(resp.data);
            const newList = resp.data?.puskicaPitanja?.map((item: any) => {
                return { ...item.pitanje, redosled: item.redosled };
            });
            console.log('selelected pitanja ', newList);
            setSelectedPitanja(newList);
        }
    };

    useEffect(() => {
        if (!!puskica?.id) {
            setValue('naziv', puskica.naziv);
            setValue('redosled', puskica.redosled);
        }
    }, [puskica]);

    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!puskica?.id) changePuskica();
        else {
            createNewPuskica();
        }
    };

    const createNewPuskica = async () => {
        const data: any = {
            naziv: getValues('naziv'),
            redosled: getValues('redosled')?.toString(),
        };
        const newList = selectedPitanja.map((e: any) => {
            return { id: e.id, redosled: e.redosled?.toString() };
        });
        data.pitanja = newList;
        console.log('create puskica data ', data);
        const resp = await createPuskica(data);
        if (resp.status === 201) {
            notif('Uspešno ste kreirali novu puškicu.');
        }
    };
    const changePuskica = async () => {
        const data: any = {
            id: selectedPuskica?.id,
            naziv: getValues('naziv'),
            redosled: getValues('redosled')?.toString(),
        };
        const newList = selectedPitanja.map((e: any) => {
            return { id: e.id, redosled: e.redosled?.toString() };
        });
        data.pitanja = newList;
        console.log('update puskica data ', data);
        const resp = await updatePuskica(data);
        if (resp.status === 201) {
            notif('Uspešno ste izmenili puškicu.');
        }
    };

    const removePitanje = (pitanje: any) => {
        const newList = selectedPitanja.filter((e: any) => e.id !== pitanje.id);
        setSelectedPitanja(newList);
    };

    const closePuskice = () => {
        setSelectedPuskica(null);
        setShowSelectedPuskica(false);
        setSelectedPitanja([]);
    };

    const handlePuskiceButton = () => {
        navigate('/user/puskice');
        setShowSelectedPuskica(false);
        setIsAdminApp(false);
    };

    const handleDrop = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...selectedPitanja];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        setSelectedPitanja(newReorderList);
    };

    return (
        <div className="flex h-fit  md:h-full  flex-col items-center bg-gradient-to-r from-blueDark via-blueMedium to-blueLight pt-5">
            <div className=" flex-1 max-w-[390px] w-full overflow-y-auto no-scroll pt-5 pb-[80px] md:pb-5 px-3">
                <form
                    className="flex flex-col items-center w-full bg-white px-[10px] py-[20px] rounded-[10px]"
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                >
                    <div className="w-full  flex flex-row items-center gap-5">
                        <div
                            className=" flex cursor-pointer items-center justify-center bg-blueMedium hover:bg-blueDark  min-w-[56px] w-[56px] h-[56px] rounded-full"
                            onClick={() => handlePuskiceButton()}
                            onMouseEnter={() => setHoveredButton(true)}
                            onMouseLeave={() => setHoveredButton(false)}
                        >
                            <TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
                        </div>
                        <label className="text-[20px] leading-6 text-beeBlack font-bold  ">{!!puskica ? 'Izmeni puškicu' : 'Kreiraj novu puškicu'}</label>
                    </div>
                    <div className="flex flex-col w-full mt-4">
                        <label className="text-[16px] leading-5 text-beeBlack font-semibold  ">Naziv puskice</label>
                        <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                            <input
                                className="text-[16px] leading-5 text-beeBlack  w-full outline-none  placeholder:text-black200 "
                                placeholder="Naziv kategorije"
                                {...register('naziv', {
                                    validate: {
                                        najduze: (value) => value.length < 30,
                                        obavezno: (value) => value.length > 0,
                                    },
                                })}
                            />
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">
                            <span>{errors.naziv?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            <span>{errors.naziv?.type === 'najduze' ? 'Duzina ne sme prelaziti 30 karaktera' : ''}</span>
                        </p>
                    </div>
                    {/* <div className='flex flex-col w-full'>
					<label className='text-[16px] leading-5 text-beeBlack font-semibold  '>Redosled puskice</label>
					<div className='bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center '>
						<input
							className='text-[16px] leading-5 text-beeBlack  w-full outline-none  placeholder:text-black200 '
							placeholder='Redosled kategorije'
							type='number'
							{...register('redosled', {
								min: 0,
							})}
						/>
					</div>
					<p className='text-redError text-[12px]  leading-5 h-5 '>
						<span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
					</p>
				</div> */}
                    <label className="text-[16px] leading-5 text-beeBlack font-semibold  ">Lista pitanja</label>
                    <div className="w-full">
                        <DragDropContext onDragEnd={handleDrop}>
                            <Droppable droppableId="list-container">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        {selectedPitanja
                                            .sort((a: any, b: any) => a.redosled - b.redosled)
                                            .map((item: any, index: number) => {
                                                return (
                                                    <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                        {(provided) => (
                                                            <div
                                                                className="flex-1 bg-white border border-b-beeBlack rounded-[4px] px-3 py-2 mt-1 flex flex-row items-center justify-between"
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <div>
                                                                    <p>
                                                                        Pitanje: <span className="font-semibold">{item?.naziv ?? ''}</span>
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    title="Ukloni pitanje iz liste pitanja"
                                                                    className="flex flex-row gap-5 cursor-pointer "
                                                                    onClick={() => removePitanje(item)}
                                                                >
                                                                    <DeleteIcon style={{ width: 20, height: 20 }} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                );
                                            })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                    <div className="w-full flex flex-row gap-5 justify-end">
                        <button
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            onClick={(e) => {
                                e.preventDefault();
                                closePuskice();
                            }}
                            type="button"
                        >
                            <p>Otkaži</p>
                        </button>
                        <button
                            type="submit"
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                            disabled={loading}
                        >
                            {loading ? (
                                <Loading size={25} />
                            ) : (
                                <div className="w-full flex flex-row items-center justify-center gap-3">
                                    <ConfirmIcon />
                                    <p>Potvrdi{!!puskica ? ' izmenu' : ''}</p>
                                </div>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SinglePuskica;
